import { render } from "./ModalConfirmarExclusaoTarefa.vue?vue&type=template&id=0daee934"
import script from "./ModalConfirmarExclusaoTarefa.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarExclusaoTarefa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__